import vSnackbar from './Snackbar.vue';

export { vSnackbar };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Snackbar/index.js